import { render, staticRenderFns } from "./NuevoVideoPlayer.vue?vue&type=template&id=2882b544"
import script from "./NuevoVideoPlayer.vue?vue&type=script&lang=js"
export * from "./NuevoVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./NuevoVideoPlayer.vue?vue&type=style&index=0&id=2882b544&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports